import { createFileRoute, useParams } from '@tanstack/react-router';

import { GradebookTab } from '@/views/admin/courses/tabs/gradebook-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/gradebook')({
  component: GradebookRoute,
});

function GradebookRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/gradebook' });
  return <GradebookTab id={id} />;
}
